/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'logout': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M23.962 12.197a.527.527 0 000-.394.472.472 0 00-.111-.166l-4.078-4.148a.494.494 0 00-.72 0c-.2.197-.2.529 0 .726l3.207 3.266H10.24a.512.512 0 00-.51.519c0 .29.228.519.51.519h12.02l-3.206 3.266c-.2.197-.2.53 0 .726a.495.495 0 00.72 0l4.077-4.148a.472.472 0 00.11-.166"/><path pid="1" d="M15.71 13.565H9.627c-.838 0-1.52-.699-1.52-1.565s.682-1.565 1.52-1.565h6.081c.28 0 .507-.23.507-.522V2.609C16.216 1.169 15.08 0 13.682 0H2.534C1.137 0 0 1.169 0 2.609V21.39C0 22.831 1.137 24 2.534 24h11.148c1.397 0 2.534-1.169 2.534-2.609v-7.304a.512.512 0 00-.507-.522"/></g>'
  }
})
